import { IsInt, IsEnum, IsBoolean, IsString, MaxLength, ValidateNested, IsOptional, IsObject, Min, Max, IsDate } from 'class-validator';

import { AssemblyLocation } from '../settings/assembly-location/assembly-location';

import { Order } from './order';
import { OrderStatus } from './order-status';
import { IOrderExternalData } from './external-data/i-order-external-data';

export class OrderUpdateRequest implements Omit<
    Order, 'positions' | 'sum' | 'totalSum' | 'created' | 'updated' | 'contrName' | 'userName' | 'dealerId' | 'priceTypeUuid' | 'paidOnline'
> {
    @IsOptional()
    @IsInt()
    public id: number;

    @IsInt()
    @IsEnum(OrderStatus)
    public status: OrderStatus; // TODO: default value backend-php/modules/rest_common/models/orders/Order.php:111

    @IsOptional()
    @IsInt()
    public contrId: number; // TODO: default value backend-php/modules/rest_common/models/orders/Order.php:102

    @IsOptional()
    @IsInt()
    @Min(0)
    @Max(100)
    public discount: number; // TODO: default value backend-php/modules/rest_common/models/orders/Order.php:112

    /**
     * TODO: set default value backend-php/modules/rest_common/models/orders/Order.php:124
     *       set gauger backend-php/modules/rest_common/models/orders/Order.php:128
     *       should exist backend-php/modules/rest_common/models/orders/Order.php:133
     */
    @IsInt()
    public personId: number;

    @IsOptional()
    @IsInt()
    public gaugerId: number;

    @IsOptional()
    @IsDate()
    public pickupDate: Date;

    @IsOptional()
    public externalData: IOrderExternalData;

    /** Necessary only for order creation */
    @IsOptional()
    @IsBoolean()
    public contrNeedDelivery: boolean; // TODO: write to OrderEntity.delivery

    @IsOptional()
    @IsBoolean()
    public orderNeedDelivery: boolean;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public comment: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public shortNote: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public contactPhone: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public contactPerson: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public pickupAddress: string;

    @IsOptional()
    @IsObject()
    @ValidateNested()
    public assemblyLocation: AssemblyLocation;

    @IsOptional()
    @IsString()
    public serviceComment: string;

    constructor(data?: Partial<OrderUpdateRequest>) {
        this.id = data?.id;
        this.status = data?.status;
        this.contrId = data?.contrId;
        this.discount = data?.discount;
        this.personId = data?.personId;
        this.gaugerId = data?.gaugerId;
        this.pickupDate = data?.pickupDate;
        this.externalData = data?.externalData;
        this.contrNeedDelivery = data?.contrNeedDelivery;
        this.orderNeedDelivery = data?.orderNeedDelivery;
        this.comment = data?.comment;
        this.shortNote = data?.shortNote;
        this.contactPhone = data?.contactPhone;
        this.contactPerson = data?.contactPerson;
        this.pickupAddress = data?.pickupAddress;
        this.assemblyLocation = typeof data?.assemblyLocation === 'object' ? new AssemblyLocation(data.assemblyLocation) : data?.assemblyLocation;
        this.serviceComment = data?.serviceComment;
    }
}
